export interface SceneTreeActorNodeLike {
  id: string;
  nodeType: 'scene' | 'folder' | 'actor';
  children?: SceneTreeActorNodeLike[];
}

export interface SceneTreeActorParentEdge {
  parentUuid: string;
  childUuid: string;
}

export interface SceneTreeActorEdgeCollectionResult {
  edges: SceneTreeActorParentEdge[];
  skippedNodeIds: string[];
}

export function collectActorParentEdgesFromTree(root: SceneTreeActorNodeLike): SceneTreeActorEdgeCollectionResult {
  const edges: SceneTreeActorParentEdge[] = [];
  const skippedNodeIds: string[] = [];
  const visitedNodeIds = new Set<string>();

  const walk = (node: SceneTreeActorNodeLike, currentParentActorUuid: string | null) => {
    if (visitedNodeIds.has(node.id)) {
      skippedNodeIds.push(node.id);
      return;
    }
    visitedNodeIds.add(node.id);

    let nextParentActorUuid = currentParentActorUuid;
    if (node.nodeType === 'actor') {
      if (currentParentActorUuid) {
        edges.push({
          parentUuid: currentParentActorUuid,
          childUuid: node.id,
        });
      }
      nextParentActorUuid = node.id;
    }

    for (const child of node.children ?? []) {
      walk(child, nextParentActorUuid);
    }
  };

  walk(root, null);
  return { edges, skippedNodeIds };
}
